import React from 'react';
import BusinessDashboardPage from '@/pages/BusinessDashboardPage';

export default function AgencyDashboardPage() {
  return <BusinessDashboardPage role="agency" />;
}
